import React, { useEffect, useState, useContext, useMemo } from "react";
import { graphql } from "gatsby";
import { Global } from "../../context/globalContextProvider";
import { empty } from "../../utilities/helper";

const ImpactStatement = ({
  bottomSubText,
  bottomBoldText,
  impactStatements: statements,
  monthlyImpactStatementFallback: monthlyImpactStatementFallbackParameter,
  onceImpactStatementFallback: onceImpactStatementFallbackParameter,
}) => {
  const { donationAmount, donationFrequency, overwriteStatement } = useContext(Global);

  const { monthlyImpactStatementFallback } = monthlyImpactStatementFallbackParameter || {
    monthlyImpactStatementFallback: null,
  };
  const { onceImpactStatementFallback } = onceImpactStatementFallbackParameter || {
    onceImpactStatementFallback: null,
  };

  const [countChildrenText] = useCountChildrenAmount(donationAmount); //custom hook

  // original:
  // changed due to error: Cannot access 'impactStatements' before initialization
  // const impactStatements = useMemo(() => {
  // const statementMap = statements && {
  //     fallback: {
  //     monthly: monthlyImpactStatementFallback,
  //     once: onceImpactStatementFallback,
  //     },
  // };
  // if (statements) {
  //     statements.forEach(({ amount, monthly, once }) => {
  //     statementMap[`${amount}`] = {
  //         monthly: monthly && monthly.monthly,
  //         once: once && once.once,
  //     };
  //     });
  // }
  // return statementMap;
  // }, [statements]);

  // const activeStatement = useMemo(() => {
  // if (impactStatements) {
  //     if (impactStatements[donationAmount] && impactStatements[donationAmount][donationFrequency]) {
  //     return impactStatements[donationAmount][donationFrequency];
  //     } else {
  //     return impactStatements.fallback[donationFrequency];
  //     }
  // }
  // return null;
  // }, [impactStatements, donationFrequency, donationAmount]);

  // Define the fallbacks in a separate useMemo
  const fallbackStatements = useMemo(
    () => ({
      monthly: monthlyImpactStatementFallback,
      once: onceImpactStatementFallback,
    }),
    [monthlyImpactStatementFallback, onceImpactStatementFallback]
  );

  // Define impactStatements using the fallbacks
  const impactStatements = useMemo(() => {
    const statementMap = statements && { fallback: fallbackStatements };
    if (statements) {
      statements.forEach(({ amount, monthly, once }) => {
        statementMap[`${amount}`] = {
          monthly: monthly?.monthly,
          once: once?.once,
        };
      });
    }
    return statementMap;
  }, [statements, fallbackStatements]);

  const activeStatement = useMemo(() => {
    if (impactStatements) {
      if (impactStatements[donationAmount] && impactStatements[donationAmount][donationFrequency]) {
        return impactStatements[donationAmount][donationFrequency];
      } else {
        return fallbackStatements[donationFrequency];
      }
    }
    return null;
  }, [impactStatements, donationFrequency, donationAmount, fallbackStatements]);

  const formatedActiveStatement = activeStatement?.replace("$$$", `$${donationAmount}`);

  return (
    <>
      {activeStatement ? (
        <div className="bottom-rich-text">{!empty(overwriteStatement) ? `$${donationAmount} ${overwriteStatement}` : formatedActiveStatement}</div>
      ) : bottomBoldText ? (
        <div className="bottom-rich-text">
          <strong>${donationAmount} </strong>
          {bottomBoldText} {countChildrenText}
        </div>
      ) : null}

      {bottomSubText ? <p className="donation_note">{bottomSubText}</p> : null}
    </>
  );
};

export default ImpactStatement;

export const query = graphql`
  fragment ImpactStatement on ContentfulImpactStatement {
    amount
    monthly {
      monthly
    }
    once {
      once
    }
  }
`;

const useCountChildrenAmount = (donationAmount) => {
  const [countChildrenText, setCountChildrenText] = useState("many");
  useEffect(() => {
    const countChildrenAmount = 39;

    if (donationAmount <= countChildrenAmount) {
      setCountChildrenText("one child");
    } else if (donationAmount <= countChildrenAmount * 2) {
      setCountChildrenText("two children");
    } else if (donationAmount <= countChildrenAmount * 3) {
      setCountChildrenText("three children");
    } else if (donationAmount <= countChildrenAmount * 4) {
      setCountChildrenText("four children");
    } else if (donationAmount <= countChildrenAmount * 5) {
      setCountChildrenText("five children");
    } else {
      setCountChildrenText("many children");
    }
  }, [donationAmount]);

  return [countChildrenText];
};
